import { featuresTypes, zIndexs } from './Options';

import UIDateFormater, { DateType } from '../../../containers/UIhelper/UIDateFormater';

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Icon, Style } from 'ol/style';
const proj = require('ol/proj');

const DAY_MILLIS = 1000 * 60 * 60 * 48; // 48 hours in milliseconds

const colorMap = {
  'active': {
    0: '#68e24aff',
    1: '#227c24ff',
  },
  'non_active': {
    0: '#e24a4aff',
    1: '#7c2222ff',
  },
  'new_pending': {
    0: '#f9be50ff',
    1: '#cc8400ff',
  },
  'not_installed': {
    0: '#6f7072',
    1: '#9a9b9d',
  },
}
/**
 *
 * @param {'active' | 'non_active' | 'new_pending' | 'not_installed'} status
 * @param {boolean} selected
 * @returns 
 */
const iconXml = (status, selected) => {
  const darkGradient0 = colorMap[status][0];
  const darkGradient1 = colorMap[status][1];

  const dialGradColor0 = selected ? '#ffff00ff' : '#ffffff';
  const dialGradColor1 = selected ? '#ffff00ff' : '#f0f1f2';

  const needleRotate = status === 'active' ? 20 : 200
  return 'data:image/svg+xml,' + encodeURIComponent(`<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 210" width="200" height="460">
  <defs>
    <!-- Generic metal gradient for highlight -->
    <linearGradient id="metalGrad" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#e6e7e8"/>
      <stop offset="0.5" stop-color="#bfc3c6"/>
      <stop offset="1" stop-color="#d7d8da"/>
    </linearGradient>

    <!-- Dark metal gradient (can be recolored) -->
    <linearGradient id="metalDark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="${darkGradient0}"/>
      <stop offset="1" stop-color="${darkGradient1}"/>
    </linearGradient>

    <!-- Background gradient for dial (you can recolor via id="dial-bg") -->
    <radialGradient id="dialGrad" cx="40%" cy="35%" r="60%">
      <stop offset="0" stop-color="${dialGradColor0}"/>
      <stop offset="1" stop-color="${dialGradColor1}"/>
    </radialGradient>
  </defs>

  <!-- Gauge head -->
  <g transform="translate(50,40)">
    <circle cx="0" cy="0" r="48" fill="url(#metalDark)"/>
    <circle cx="0" cy="0" r="40" fill="url(#metalGrad)" stroke="#8b8c8e" stroke-width="2"/>

    <!-- This layer is the dial background (color can be changed) -->
    <circle id="dial-bg" cx="0" cy="0" r="32" fill="url(#dialGrad)" stroke="#9a9b9d" stroke-width="1.5"/>

    <!-- Tick lines -->
    <g stroke="#333" stroke-width="1" stroke-linecap="round">
      <line x1="0" y1="-32" x2="0" y2="-27"/>
      <line x1="0" y1="32" x2="0" y2="27"/>
      <line x1="32" y1="0" x2="27" y2="0"/>
      <line x1="-32" y1="0" x2="-27" y2="0"/>
      <line x1="22.6" y1="-22.6" x2="19.6" y2="-19.6"/>
      <line x1="-22.6" y1="-22.6" x2="-19.6" y2="-19.6"/>
      <line x1="22.6" y1="22.6" x2="19.6" y2="19.6"/>
      <line x1="-22.6" y1="22.6" x2="-19.6" y2="19.6"/>
    </g>

    <!-- Pointer (needle) -->
    <line x1="0" y1="0" x2="0" y2="-22" stroke="#d62828" stroke-width="3" stroke-linecap="round" transform="rotate(${needleRotate})"/>
    <circle cx="0" cy="0" r="4" fill="#555" stroke="#333" stroke-width="0.8"/>
  </g>

  <!-- Connector -->
  <rect x="35" y="82" width="30" height="28" rx="4" fill="url(#metalDark)" stroke="#9a9b9d" stroke-width="1"/>

  <!-- Body (pipe) -->
  <g transform="translate(50,110)">
    <rect x="-7.5" y="0" width="15" height="110" rx="10" fill="url(#metalDark)" stroke="#9a9b9d" stroke-width="1.2"/>
    <!-- Small highlight -->
    <rect x="-3" y="0" width="6" height="95" rx="3" fill="rgba(0,0,0,0.06)"/>
  </g>
</svg>
`)
};

const alarmIcon = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
  <!-- Red circle with white border -->
  <circle cx="32" cy="32" r="30" fill="red"/>

  <!-- Exclamation mark in the center, scaled up -->
  <g transform="translate(32, 32)">
    <!-- Main vertical bar of the exclamation mark -->
    <rect x="-2.5" y="-14" width="5" height="22" rx="2" fill="white"/>
    <!-- Dot at the bottom -->
    <rect x="-2.5" y="10" width="5" height="5" rx="2" fill="white"/>
  </g>
</svg>`)}`;

const transientAlarmIcon = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
  <!-- Red circle with white border -->
  <circle cx="32" cy="32" r="30" fill="orange"/>

  <!-- Exclamation mark in the center, scaled up -->
  <g transform="translate(32, 32)">
    <!-- Main vertical bar of the exclamation mark -->
    <rect x="-2.5" y="-14" width="5" height="22" rx="2" fill="white"/>
    <!-- Dot at the bottom -->
    <rect x="-2.5" y="10" width="5" height="5" rx="2" fill="white"/>
  </g>
</svg>`)}`;

// Inline SVG as data URL for pressure sensor icon with gauge
const pressureSensorIcon = iconXml('active', false); // generatePressureSensorIcon('cornflowerblue');
const pressureSensorIconNoDevice = iconXml('not_installed', false); // generatePressureSensorIcon('lightgray');

const itemStyle = new Style({
  image: new Icon({
    src: pressureSensorIcon,
    anchor: [0.5, 1],
    scale: 0.5
  })
});

const source = new VectorSource({
  features: [],
});

// Pressure Sensors layer
export const layer = new VectorLayer({
  name: 'layerPressureSensors',
  style: itemStyle,
  source: source,
  zIndex: zIndexs.sensors_pressure, // Render behind regular sensors
});

// Pressure Sensors source
export const setSource = (nextIconFeatures, props) => {
  let iconFeatures = [];
  Object.keys(nextIconFeatures).forEach((key) => {
    const sensor = nextIconFeatures[key];
    const iconFeature = new Feature({
      geometry: new Point(
        proj.transform(
          sensor.position,
          'EPSG:4326',
          'EPSG:3857'
        )
      ),
      type: featuresTypes.PRESSURE_SENSOR,
      id: sensor.id,
      loggerId: sensor.loggerId,
      aqsLoggerId: sensor.aqsLoggerId,
      typeMeaning: sensor.typeMeaning,
      manufactureName: sensor.manufactureName,
      loggerInstallationDate: sensor.loggerInstallationDate,
      loggerLastActiveTime: sensor.loggerLastActiveTime ? new Date(sensor.loggerLastActiveTime) : undefined,
      lastTrendAlarm: sensor.lastTrendAlarm ? new Date(sensor.lastTrendAlarm) : undefined,
      lastTransientEvent: sensor.lastTransientEvent ? new Date(sensor.lastTransientEvent) : undefined,
      address: sensor.address,
    });
    iconFeature.setStyle(getStyle(iconFeature, false, props));
    iconFeatures.push(iconFeature);
  });

  layer.getSource().addFeatures(iconFeatures);
};

// Get pressure sensor style with selection highlighting
export const getStyle = (feature, selected, props) => {
  const hasDevice = feature.get('aqsLoggerId') != null;
  const lastActiveTime = feature.get('loggerLastActiveTime');
  const loggerInstallationDate = feature.get('loggerInstallationDate');
  const active = hasDevice && lastActiveTime && (Date.now() - lastActiveTime.getTime() < DAY_MILLIS);

  // Determine status:
  // - not_installed: no device
  // - active: device with readings in last 24 hours
  // - new_pending: inactive but installed within last 2 days (orange)
  // - non_active: inactive and installed more than 2 days ago (red)
  let status;
  if (!hasDevice) {
    status = 'not_installed';
  } else if (active) {
    status = 'active';
  } else {
    // Check if sensor was installed within last 2 days
    const installDate = loggerInstallationDate ? new Date(loggerInstallationDate) : null;
    const isNewInstallation = installDate && (Date.now() - installDate.getTime() < DAY_MILLIS * 2);
    status = isNewInstallation ? 'new_pending' : 'non_active';
  }

  const iconSrc = iconXml(status, selected);

  const mainStyle = [
    new Style({
      image: new Icon({
        src: iconSrc,
        anchor: [0.5, 1],
        scale: 0.15
      }),
      zIndex: selected ? 999 : zIndexs.sensors_pressure
    })
  ];

  const lastAlarmDate = feature.get('lastTrendAlarm');
  if (lastAlarmDate && Date.now() - lastAlarmDate.getTime() < (DAY_MILLIS * 2)) {
    mainStyle.push(new Style({
      image: new Icon({
        src: alarmIcon,
        anchor: [1.2, 3.8],
        scale: 0.3,
      }),
      zIndex: selected ? 999 : zIndexs.sensors_pressure
    }))
  }

  const lastTransientEventDate = feature.get('lastTransientEvent');
  if (lastTransientEventDate && Date.now() - lastTransientEventDate.getTime() < (DAY_MILLIS * 2)) {
    mainStyle.push(new Style({
      image: new Icon({
        src: transientAlarmIcon,
        anchor: [-0.2, 3.8],
        scale: 0.3,
      }),
      zIndex: selected ? 999 : zIndexs.sensors_pressure
    }))
  }

  return mainStyle;
};

export const getLayers = () => {
  return [layer];
}

export const hasFeatures = () => {
  return source.getFeatures().length > 0;
};

// Clean the layer
export const clear = () => {
  if (source.getFeatures().length) {
    source.clear();
  }
};

export const getInfoTooltip = (feature) => {
  const attr = feature.getProperties();
  let infoTooltip = {
    type: attr.type,
    id: attr.id,
    loggerId: attr.loggerId,
    aqsLoggerId: attr.aqsLoggerId,
    typeMeaning: attr.typeMeaning,
    manufactureName: attr.manufactureName,
    loggerInstallationDate: attr.loggerInstallationDate,
    loggerLastActiveTime: attr.loggerLastActiveTime,
    address: attr.address,
  };
  return (infoTooltip);
};

export const tooltipRender = (itemInfo, context, props) => {
  const {
    id,
    loggerId,
    aqsLoggerId,
    typeMeaning,
    manufactureName,
    address,
    loggerInstallationDate,
    loggerLastActiveTime
  } = itemInfo;

  return (
    <span className="tooltip">
      <div className="tooltip-row">{context.t('sensor_id_param', { id: id })}</div>

      {loggerId &&
        <div className="tooltip-row">{context.t('logger_id')}: {loggerId}</div>
      }

      {aqsLoggerId &&
        <div className="tooltip-row">{context.t('aqs_logger_id')}: {aqsLoggerId}</div>
      }

      {typeMeaning &&
        <div className="tooltip-row">{context.t('type')}: {typeMeaning}</div>
      }

      {manufactureName &&
        <div className="tooltip-row">{context.t('manufacturer')}: {manufactureName}</div>
      }

      {address &&
        <div className="tooltip-row">{context.t('address_param', { address: address })}</div>
      }

      {loggerInstallationDate &&
        <div className="tooltip-row">{context.t('logger_install_date')}: {UIDateFormater(loggerInstallationDate, DateType.DATE_AND_TIME, props.timeZone, props.projectTimezone)}</div>
      }

      {loggerLastActiveTime &&
        <div className="tooltip-row">{context.t('last_active')}: {UIDateFormater(loggerLastActiveTime?.getTime(), DateType.DATE_AND_TIME, props.timeZone, props.projectTimezone)}</div>
      }
    </span>
  );
};
